export const portalContainerId = 'portal-container';
export const PortalContainer: React.FC = () => <div id={portalContainerId} />;
